function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 2.98898C0 2.87294 0.0185185 2.7569 0.0555556 2.64086C0.111111 2.52482 0.185185 2.41845 0.277778 2.32176C0.37037 2.22506 0.462963 2.15737 0.555556 2.11869L4.44444 0.494141V11.6339L0.611111 13.4615C0.462963 13.5195 0.324074 13.5002 0.194444 13.4035C0.0648148 13.3068 0 13.1811 0 13.0264V2.98898ZM5.33333 11.6339V0.494141L10.6667 2.35077V13.4905L5.33333 11.6339ZM15.3889 0.52315C15.5 0.484471 15.5926 0.484471 15.6667 0.52315C15.7593 0.54249 15.8333 0.59084 15.8889 0.668199C15.963 0.745559 16 0.842258 16 0.958297V10.9957C16 11.1117 15.9722 11.2278 15.9167 11.3438C15.8796 11.4598 15.8148 11.5662 15.7222 11.6629C15.6296 11.7596 15.537 11.8273 15.4444 11.866L11.5556 13.4905V2.35077L15.3889 0.52315Z",
  fill: "#2C2C2A"
});

var SvgMapIcon = function SvgMapIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mapIcon.3c91aed5.svg";
export { ForwardRef as ReactComponent };